import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

function getAdminAuthConfig() {
  const token = sessionStorage.getItem("accessToken");

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

/*
|--------------------------------------------------------------------------
| LIST MODULES
|--------------------------------------------------------------------------
*/

export async function getModulesApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append("page", payload.page || 1);
    fd.append("limit", payload.limit || 6);
    fd.append("search", payload.search || "");
    fd.append("course_id", payload.course_id || "");
    fd.append("module_type", payload.module_type || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/modules/list`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Modules Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Modules fetch failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| MODULE STATS
|--------------------------------------------------------------------------
*/

export async function getModuleStatsApi() {
  try {
    const res = await axios.post(
      `${apiBaseUrl}admin/modules/stats`,
      {},
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Module Stats Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Module stats fetch failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| VIEW MODULE
|--------------------------------------------------------------------------
*/

export async function getModuleApi(moduleId) {
  try {
    const fd = new FormData();

    fd.append("module_id", moduleId || "");

    const res = await axios.post(
      `${apiBaseUrl}admin/modules/view`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Get Module Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Module fetch failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| CREATE MODULE
|--------------------------------------------------------------------------
*/

export async function createModuleApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append(
      "module_parent",
      payload.module_parent || ""
    );

    fd.append(
      "module_title",
      payload.module_title || ""
    );

    fd.append(
      "module_meta_title",
      payload.module_meta_title || ""
    );

    fd.append(
      "module_keyword",
      payload.module_keyword || ""
    );

    fd.append(
      "module_desc",
      payload.module_desc || ""
    );

    fd.append(
      "module_type",
      payload.module_type || ""
    );

    fd.append(
      "module_img",
      payload.module_img || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/modules/create`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Create Module Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Module creation failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| UPDATE MODULE
|--------------------------------------------------------------------------
*/

export async function updateModuleApi(payload = {}) {
  try {
    const fd = new FormData();

    fd.append(
      "module_id",
      payload.module_id || ""
    );

    fd.append(
      "module_parent",
      payload.module_parent || ""
    );

    fd.append(
      "module_title",
      payload.module_title || ""
    );

    fd.append(
      "module_meta_title",
      payload.module_meta_title || ""
    );

    fd.append(
      "module_keyword",
      payload.module_keyword || ""
    );

    fd.append(
      "module_desc",
      payload.module_desc || ""
    );

    fd.append(
      "module_type",
      payload.module_type || ""
    );

    fd.append(
      "module_img",
      payload.module_img || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/modules/update`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Update Module Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Module update failed",
    };
  }
}

/*
|--------------------------------------------------------------------------
| DELETE MODULE
|--------------------------------------------------------------------------
*/

export async function deleteModuleApi(moduleId) {
  try {
    const fd = new FormData();

    fd.append(
      "module_id",
      moduleId || ""
    );

    const res = await axios.post(
      `${apiBaseUrl}admin/modules/delete`,
      fd,
      getAdminAuthConfig()
    );

    return res.data;
  } catch (err) {
    console.error("Delete Module Error:", err);

    return {
      status: false,
      type: "danger",
      success: "Module deletion failed",
    };
  }
}